import { render, staticRenderFns } from "./BoubleModalView.vue?vue&type=template&id=ca8976b0&"
import script from "./BoubleModalView.vue?vue&type=script&lang=js&"
export * from "./BoubleModalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports